import { useTranslation } from "react-i18next";
import "./style.css";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import Service from "../../services/Service";
import { useSelector } from "react-redux";
import StaticService from "../../services/StaticService";
import BannerService from "../../services/BannerService";

const Static = ({ type }) => {
	const [data, setData] = useState([]);
	const [bg, setBg] = useState("");
	const { t } = useTranslation();
	const lang = useSelector((state) => state.lang.lang);

	useEffect(() => {
		if (type === "about") {
			new Service().getList("staticPage/aboutUs").then((res) => {
				if (res.status === 200) {
					let response = res?.data?.data;
					if (!!response) {
						setData(response);
					}
				}
			});
		} else {
			new StaticService().getList({ type: type }).then((res) => {
				if (res.status === 200) {
					let response = res?.data?.data;
					if (!!response?.length) {
						setData(response[0]);
					}
				}
			});
		}
		new BannerService().getList("contact").then((res) => {
			if (res?.status) {
				let url = res?.data?.data?.banner_images;
				if (!!url?.length) {
					setBg(url[0].url);
				}
			}
		});
	}, [type]);

	return (
		<div className="main-page">
			<Helmet>
				<title>
					{t("afkar")} |{" "}
					{type === "terms"
						? t("Terms & Conditions")
						: type === "about"
						? t("about-us")
						: t("Privacy Policy")}
				</title>
			</Helmet>
			<div className="header" style={{ backgroundImage: `url(${bg})` }}>
				<div className="shadow"></div>
				<p className="header-title">
					{type === "terms"
						? t("Terms & Conditions")
						: type === "about"
						? t("about-us")
						: t("Privacy Policy")}
				</p>
			</div>
			<div className="static">
				<div className="container">
					<p
						dangerouslySetInnerHTML={{
							__html: data[`description_${lang}`],
						}}></p>
					{type === "about" && data?.about_us_values?.length && (
						<div className="about">
							{data?.about_us_values?.map((res, index) => {
								return (
									<div
										className={`about-card mb-4 ${
											index % 2 === 0 ? "one" : "two"
										}`}
										data-aos="zoom-in">
										{index % 2 === 0 ? (
											<>
												<img src={res?.image} alt="about" />
												<div className="details">
													<p
														className="details-title"
														dangerouslySetInnerHTML={{
															__html: res[`title_${lang}`],
														}}></p>
													<p
														className="details-description"
														dangerouslySetInnerHTML={{
															__html: res[`description_${lang}`],
														}}></p>
												</div>
											</>
										) : (
											<>
												<div className="details">
													<p
														className="details-title"
														dangerouslySetInnerHTML={{
															__html: res[`title_${lang}`],
														}}></p>
													<p
														className="details-description"
														dangerouslySetInnerHTML={{
															__html: res[`description_${lang}`],
														}}></p>
												</div>
												<img src={res?.image} alt="about" />
											</>
										)}
									</div>
								);
							})}
							{/* <div className="about-card one mb-4" data-aos="zoom-in">
								<img src={bg} alt="about" />
							</div>
							<div className="about-card two" data-aos="zoom-in">
								<div className="details">
									<p className="details-title">{t("Our Mission")}</p>
									<p className="details-description">
										It is a long established fact that a reader will be
										distracted by the readable content of a page when looking at
										its layout. The point of using Lorem Ipsum is that it has a
										more-or-less normal distribution of letters, as opposed to
										using 'Content here, content here', making it look like
										readable English. Many desktop publishing packages and web
										page editors now use Lorem Ipsum as their default model
										text, and a search for 'lorem ipsum' will uncover many web
										sites still in their infancy. Various versions have evolved
										over the years, sometimes by accident, sometimes on purpose
										(injected humour and the like).
									</p>
								</div>
								<img src={bg} alt="about" />
							</div> */}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
export default Static;
